import { render } from "./AllArticlesView.vue?vue&type=template&id=4e6c39ee&scoped=true"
import script from "./AllArticlesView.vue?vue&type=script&lang=js"
export * from "./AllArticlesView.vue?vue&type=script&lang=js"

import "./AllArticlesView.vue?vue&type=style&index=0&id=4e6c39ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e6c39ee"

export default script